import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.createModal';

export default defineMessages({
  newProject: {
    id: `${scope}.newProject`,
    defaultMessage: 'New Project',
  },
  projectName: {
    id: `${scope}.projectName`,
    defaultMessage: 'Project name',
  },
  projectNamePlaceholder: {
    id: `${scope}.projectNamePlaceholder`,
    defaultMessage: 'E.g. Biology',
  },
  projectNameValidationIsRequired: {
    id: `${scope}.projectNameValidationIsRequired`,
    defaultMessage: 'Required',
  },
  createProject: {
    id: `${scope}.createProject`,
    defaultMessage: 'Create project',
  },
});
